import { DecimalPipe } from '@angular/common'
import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { PoLineItemBase } from './po-line-item.model'

@Component({
    selector: 'app-po-common-fields',
    templateUrl: './po-common-fields.component.html',
    standalone: true,
    imports: [DecimalPipe, FormsModule, WjInputModule],
})
export class PoCommonFieldsComponent {
    item = input.required<PoLineItemBase>()
    glAccountReadonly = input(true)

    taxTypeOptions = ['', '1-Sales', '2-Use']
}
